import { render, staticRenderFns } from "./UpgradeDm.vue?vue&type=template&id=64c4965b&scoped=true&"
import script from "./UpgradeDm.vue?vue&type=script&lang=js&"
export * from "./UpgradeDm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4965b",
  null
  
)

export default component.exports